export const RootPath = 'https://services.aprilianta.com';